<template>
  <div class="giftPage" :style="'height:'+fullHeight+'px;'">
    <!-- header start -->
    <van-nav-bar
      title="祭品步行街"
      class="mynavbar"
      left-arrow
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    ></van-nav-bar>
    <!-- header end -->

    <img src="@/assets/images/worship/gift_bg.png" class="giftBg" />
    <div class="sroll-content" :style="'height:'+(fullHeight-46-38)+'px;'">
      <section
        class="giftSwiper"
        v-for="item in groupSacrificeList"
        :key="item.id"
        v-show="showSetMeal == false"
      >
        <div class="gift-title">{{item.GroupName}}</div>
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(citem,index) in item.SacrificeList" :key="index">
            <div class="gift-item" @click="onBuyShow(citem)">
              <h2 class="name">{{citem.SacrificeName}}</h2>
              <van-image width="100%" height="100%" fit="contain" :src="citem.CoverPhotoPath" />
              <p class="price">{{citem.Coin == 0 ?'免费': citem.Coin}}</p>
            </div>
          </swiper-slide>
          <!-- <swiper-slide>
            <div class="gift-item" @click="giftPopupShow = true">
              <h2 class="name">菊花</h2>
              <van-image
                width="100%"
                height="100%"
                fit="contain"
                src="http://img2.huaien.com/jinian/material/j03/j03_t_01.png"
              />
              <p class="price">100</p>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="gift-item" @click="giftPopupShow = true">
              <h2 class="name">菊花</h2>
              <van-image
                width="100%"
                height="100%"
                fit="contain"
                src="http://img2.huaien.com/jinian/material/j04/j04_t_43.png"
              />
              <p class="price">100</p>
            </div>
          </swiper-slide>
          <swiper-slide v-for="item in 8" :key="item.id">
            <div class="gift-item" @click="giftPopupShow = true">
              <h2 class="name">百合花</h2>
              <van-image
                width="100%"
                height="100%"
                fit="contain"
                src="http://img2.huaien.com/jinian/material/j04/j04_t_01.png"
              />
              <p class="price">100</p>
            </div>
          </swiper-slide>-->
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </section>

      <!-- 祭品套餐 -->
      <section v-if="packgeList" v-show="showSetMeal">
        <div v-for="item in packgeList[0].SacrificeList" :key="item.Id">
          <router-link
            class="gift-package-list"
            :to="{path:'/GiftPackageDetails', query:{id:item.SerialNumber}}"
          >
            <div class="hd">
              <van-image width="100%" height="100%" fit="cover" :src="item.CoverPhotoPath" />
            </div>
            <div class="bd">
              <h2 class="name">{{item.SacrificeName}}</h2>
              <p class="des">{{item.SacrificeSubName}}</p>
              <van-button plain round type="primary" color="yellow" size="small" class="btn">查看详情</van-button>
            </div>
          </router-link>
        </div>
      </section>
    </div>

    <div class="tabbar-footer">
      <div class="item" v-for="(item,index) in typeList" :key="index">
        <div
          :class="{active:activeIndex== item.Id}"
          @click="tabchange(item)"
        >{{item.SacrificeTypeName}}</div>
      </div>
    </div>
    <!-- <div class="tabbar-footer" >
      <div class="item" :class="{active:activeIndex==0}" @click="activeIndex=0">贡品</div>
      <div class="item" :class="{active:activeIndex==1}" @click="activeIndex=1">香烛</div>
      <div class="item" :class="{active:activeIndex==2}" @click="activeIndex=2">行礼</div>
      <div class="item" :class="{active:activeIndex==3}" @click="activeIndex=3">祝福</div>
      <div class="item" :class="{active:activeIndex==4}" @click="activeIndex=4">套餐</div>
    </div>-->

    <!-- 购买祭品弹出 -->
    <van-popup v-if="sacrifice" v-model="giftPopupShow">
      <div class="gift-buy-popup">
        <img
          src="@/assets/images/worship/close_icon.png"
          class="closeBtn"
          @click="giftPopupShow = false"
        />
        <div class="box">
          <van-image width="110" height="110" fit="contain" :src="sacrifice.SacrificePath" />
          <h2 class="name">{{sacrifice.SacrificeName}}</h2>
          <P class="des">({{coin}})</P>
          <div class="cells">
            <div class="cell">默认时间: 1天</div>
            <div class="cell">
              时间：
              <van-stepper v-model="dayStep" @change="onchangeday()" />
            </div>
            <!-- <div class="cell">
              数量：
              <van-stepper v-model="numStep" />
            </div>-->
          </div>
          <van-button size="small" color="#f60" class="btn" @click="buysacrifice()">祭拜</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import placeTypeStatus from "@/static/sacrificePlaceTypeStatus";
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      muid: "",
      placeType: 0,
      activeIndex: 0,
      showSetMeal: false,
      dayStep: 1,
      numStep: 1,
      giftPopupShow: false,
      typeList: null,
      classId: 0,
      groupSacrificeList: null,
      options: null,
      loadTypeList: false,
      packgeList: null,
      sacrifice: null,
      coin: "",
      bc: null
    };
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        var that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    this.get_bodyHeight();
  },
  methods: {
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      var that = this;
      that.options = {
        type: "GetSacrificeSacrificeSearchList",
        PlaceType: that.placeType
      };
      this.getList();
    },
    // onRefresh() {
    //   var that = this;
    //   Object.assign(this.options, {
    //     ClassId: that.classId,
    //   });
    //   this.getList();
    // },
    getList() {
      var that = this;
      this.$store.dispatch(that.options).then(
        res => {
          that.groupSacrificeList = res.GroupSacrificeList;
          if (that.loadTypeList == false) {
            that.activeIndex = res.MainSacrificeTypeList[0].Id;
            that.typeList = res.MainSacrificeTypeList;
            that.loadTypeList = true;
          }
        },
        err => {}
      );
    },
    tabchange(item) {
      var that = this;
      that.activeIndex = item.Id;
      if (item.SacrificeTypeName.indexOf("套餐") > -1) {
        that.showSetMeal = true;
      } else {
        that.showSetMeal = false;
      }
      that.classId = item.Id;
      that.$store
        .dispatch({
          type: "GetGroupSacrificeListByClassId",
          ClassId: that.classId
        })
        .then(
          res => {
            if (that.showSetMeal) {
              that.packgeList = res;
            } else {
              that.groupSacrificeList = res;
            }
          },
          err => {}
        );
    },
    onBuyShow(item) {
      var that = this;
      that.giftPopupShow = true;
      that.sacrifice = item;
      that.dayStep = 1;
      that.coin = item.Coin == 0 ? "免费" : item.Coin + "纪念币";
    },
    onchangeday() {
      if (this.sacrifice.Coin != 0) {
        this.coin = this.sacrifice.Coin * this.dayStep + "纪念币";
      }
    },
    buysacrifice() {
      var that = this;
      Dialog.confirm({
        message:
          "您确定花费" +
          that.coin +
          "，购买" +
          that.sacrifice.SacrificeName +
          "祭品吗？"
      })
        .then(() => {
          that.$store
            .dispatch({
              type: "AddSacrificeSacrificeBuyVue",
              Id: that.sacrifice.SerialNumber,
              Day: that.dayStep,
              PlaceType: that.placeType,
              MemorialHallID: that.muid
            })
            .then(
              res => {
                console.log(res);
                if (res.IsSuccess) {
                  //if(that.placeType == placeTypeStatus.MourningHall){
                    that.$store.commit("setSacrifice", that.sacrifice);
                  //}
                  that.$router.go(-1);
                }
                else{
                  Toast(res.Message)

                }
              },
              err => {}
            );
        })
        .catch(() => {});
    }
  },
  created() {
    var that = this;
    that.placeType = this.$store.state.placeType;
    that.muid = this.$store.state.muid;
    this.init();
  }
};
</script>

<style scoped>
.giftPage {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.giftBg {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.giftPage .mynavbar {
  background: url("~@/assets/images/worship/appbar_bg.png") center center
    no-repeat !important;
  background-size: cover !important;
}
.giftPage .mynavbar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
}
.gift-item {
  padding: 0 10px;
  overflow: hidden;
  text-align: center;
}
.gift-item > .name {
  font-weight: normal;
  font-size: 13px;
  color: #ffd887;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  margin-bottom: 4px;
}
.gift-item > .price {
  display: block;
  font-size: 10px;
  color: yellow;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: rgba(151, 86, 27, 0.64);
  border-radius: 4px;
  text-align: center;
  padding: 0 10px;
}
.giftSwiper {
  background: url("~@/assets/images/worship/gift_floor_bg.png") left bottom
    no-repeat;
  background-size: 100% auto;
  position: relative;
  margin-bottom: 20px;
}
.swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: yellow; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 18px; /* 设置按钮大小 */
}
.gift-title {
  background: url("~@/assets/images/worship/gift_tit_bg.png") center no-repeat;
  background-size: 100% 100%;
  font-size: 13px;
  color: yellow;
  width: 103px;
  height: 37px;
  margin: 24px auto 10px;
  text-align: center;
  padding-top: 5px;
}
.sroll-content {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.tabbar-footer {
  display: flex;
  align-items: center;
  background: url("~@/assets/images/worship/tab_bg.png") center no-repeat;
  background-size: 100% 100%;
  height: 38px;
  position: relative;
}
.tabbar-footer > .item {
  flex: 1;
  height: 38px;
  overflow: hidden;
  position: relative;
  font-size: 14px;
  color: yellow;
  text-align: center;
  line-height: 38px;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 4px;
}
/* .tabbar-footer > .item.active {
  background: url("~@/assets/images/worship/tab_bg_active.png") center no-repeat;
  background-size: cover;
} */
.tabbar-footer > .item > .active {
  background: url("~@/assets/images/worship/tab_bg_active.png") center no-repeat;
  background-size: cover;
}
.van-popup {
  background-color: transparent !important;
}
.gift-buy-popup {
  background: url("~@/assets/images/worship/gift_buy_bg.png") center no-repeat;
  background-size: 100% 100%;
  width: 314px;
  position: relative;
  margin: 10px;
  padding: 36px 20%;
}
.gift-buy-popup .closeBtn {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: -10px;
  margin-right: -10px;
  width: 28px;
  height: 28px;
}
.gift-buy-popup > .box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}
.gift-buy-popup > .box > .name {
  font-size: 16px;
  color: #f60;
  font-weight: normal;
  margin-top: 10px;
  text-align: center;
}
.gift-buy-popup > .box > .des {
  font-size: 14px;
  color: #999;
  text-align: center;
}
.gift-buy-popup > .box > .cells {
  margin-top: 10px;
}
.gift-buy-popup > .box > .cells > .cell {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #777;
}
.gift-buy-popup .btn {
  margin-top: 15px;
}
.gift-package-list {
  display: flex;
  align-items: center;
  padding: 15px 15px 40px;
  position: relative;
  background: url("~@/assets/images/worship/gift_floor_bg.png") left bottom
    no-repeat;
  background-size: 100% auto;
}
.gift-package-list > .hd {
  width: 218px;
  height: 125px;
  margin-right: 10px;
}
.gift-package-list > .bd {
  flex: 1;
  overflow: hidden;
  padding: 10px;
}
.gift-package-list > .bd > .name {
  font-weight: normal;
  font-size: 18px;
  color: yellow;
}
.gift-package-list > .bd > .name {
  font-weight: normal;
  font-size: 18px;
  color: yellow;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gift-package-list > .bd > .des {
  font-weight: normal;
  font-size: 14px;
  color: #333;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 4px;
}
.gift-package-list > .bd > .btn {
  margin: 10px auto;
  display: block;
}
.gift-package-list > .bd > .btn.van-button--plain {
  background-color: transparent !important;
}
</style>
